import type {PromotionTool} from './types';

import couponImage from 'assets/images/promotion-center/coupon.svg';
import cpcImage from 'assets/images/promotion-center/cpcClick.svg';
import pinImage from 'assets/images/promotion-center/new/pin.svg';
import customDealImage from 'assets/images/promotion-center/new/tn-green.svg';
import promotionCenterImage from 'assets/images/promotion-center/new/tn.svg';
import vendorProImage from 'assets/images/promotion-center/vendor-pro.svg';

export const PROMOTION_TOOLS: PromotionTool[] = [
  {
    id: 'promotion_center',
    title: 'مشارکت در تخفیف',
    path: '/services/promotion-center/info',
    image: promotionCenterImage
  },
  {
    id: 'custom_deal',
    title: 'تخفیف سوپرمارکت شما',
    path: '/services/promotion-center/custom-deal',
    image: customDealImage
  },
  {
    id: 'pin',
    title: 'نمایش در جایگاه دوم (پین)',
    path: '/services/promotion-center/pin-list',
    image: pinImage
  },
  {
    id: 'cpc',
    title: 'کلیک',
    path: '/cpc/list',
    image: cpcImage
  },
  {
    id: 'coupon',
    title: 'کوپن',
    path: '/services/promotion-center/coupon/list',
    image: couponImage
  },
  {
    id: 'pro',
    title: 'پرو',
    path: '/services/promotion-center/pro/list',
    image: vendorProImage
  }
];
